import * as React from 'react'

export function Facebook(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M17.471 9.058h-3.185V6.97c0-.785.52-.967.886-.967h2.248v-3.45l-3.096-.012c-3.437 0-4.22 2.573-4.22 4.22v2.298H8.118v3.555h1.988V22.67h4.18V12.613h2.822l.364-3.555z"
                fill="currentColor"
            />
        </svg>
    )
}
